export default "__VITE_PUBLIC_ASSET__688f96cf__"